import { useEffect, useMemo, useState } from 'react';
import { Modal, Input, Table } from 'antd';

// ════════════════════════════════════════════════════════════════════
// Glass Config popup (the GlassMaster "glass popup"): a scratch config table
// — thickness / coating / film / spacer specs for the row's glass. Seeded from
// the row's item description. Informational/scratch (not persisted to the line,
// matching the reference).
// ════════════════════════════════════════════════════════════════════

const HEADERS = [
  ['itemDesc', 'ITEM DESC'], ['thick', 'THICK'], ['coating', 'COATING'], ['sqmtPrice', 'SQMT PRICE'],
  ['filmType', 'FILM TYPE'], ['filmThickness', 'FILM THICK'], ['filmPrice', 'FILM PRICE'],
  ['spacer', 'SPACER'], ['bendable', 'BENDABLE'], ['spacerPrice', 'SPACER PRICE']
];

function seedRows(row) {
  const desc = (row && row.itemDesc ? String(row.itemDesc).trim() : '') || '12MM CLEAR';
  const th = (desc.match(/(\d+)/) || [])[1] || '12';
  return [
    { itemDesc: desc, thick: th, coating: '', sqmtPrice: '', filmType: 'PVB', filmThickness: '1.52', filmPrice: '', spacer: '', bendable: '', spacerPrice: '' },
    { itemDesc: desc, thick: th, coating: '', sqmtPrice: '', filmType: '', filmThickness: '', filmPrice: '', spacer: '12MM', bendable: 'N', spacerPrice: '' }
  ];
}

export default function GlassConfigModal({ open, onClose, row }) {
  const [rows, setRows] = useState([]);
  useEffect(() => { if (open) setRows(seedRows(row)); }, [open, row]);

  const update = (ri, key, val) => setRows((p) => p.map((r, i) => (i === ri ? { ...r, [key]: val } : r)));
  const columns = useMemo(() => HEADERS.map(([key, label], idx) => ({
    title: label, dataIndex: key, width: idx === 0 ? 220 : 96,
    render: (_v, _r, ri) => (
      <Input size="small" variant="borderless" value={rows[ri] ? rows[ri][key] : ''} onChange={(e) => update(ri, key, e.target.value)} />
    )
  })), [rows]);

  return (
    <Modal title="Glass config" open={open} onCancel={onClose} onOk={onClose} okText="Close" cancelButtonProps={{ style: { display: 'none' } }} width={920} destroyOnClose>
      <Table size="small" rowKey={(_r, i) => i} columns={columns} dataSource={rows} pagination={false} bordered scroll={{ x: 900 }} />
    </Modal>
  );
}
